import { render, staticRenderFns } from "./step-editor.vue?vue&type=template&id=3dde34f4&scoped=true&"
import script from "./step-editor.vue?vue&type=script&lang=js&"
export * from "./step-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dde34f4",
  null
  
)

export default component.exports